import { Subject } from "rxjs";

const modalSubject = new Subject();
const defaultId = "default-modal";

export const modalService = {
  onModal,
  open,
  close,
};

// enable subscribing to modal observable
function onModal() {
  return modalSubject.asObservable();
}
// core alert method
function open(modal) {
  modal.id = modal.id || defaultId;
  modalSubject.next(modal);
}

// clear alerts
function close(id = defaultId) {
  modalSubject.next({ id });
}
